import { Flags } from "@livechat/design-system-icons";

import { capitalizeFirstLetter } from "utils/string";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

export const actionFilterConfig: IFilterConfig = {
  title: "Change type",
  icon: Flags,
  multiple: false,
  getFilterLabelValues: (filterValues: string | null): IFilterLabelValue[] => {
    if (filterValues === null) {
      return [];
    }
    return [
      {
        key: filterValues,
        label: capitalizeFirstLetter(filterValues),
      },
    ];
  },
};
